<script setup lang="ts">
    import { defineProps } from 'vue';
    interface Props {
        img: string,
        nivel: string,
        carrera?: string,
        complemento?: string,
        intro: string,
        beneficios?: string,
        beneuno?: string,
        benedos?: string,
        benetres?: string,
        alt?: string,
        perfil: string,
        fechas: string,
        duracion: string
    }

    defineProps<Props>();
</script>

<template>
    <section class="flex items-center justify-center w-full">
        <div class="lg:flex items-center justify-start w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <div class="flex flex-col text-justify lg:mr-12 w-full lg:w-1/2">
                <img :src="img" loading="lazy" :alt="alt">
            </div>
            <div class="flex flex-col text-justify lg:hyphens-none hyphens-auto w-full lg:w-1/2 pt-4">
                <h2 class="mb-4 text-left">
                    <span class="block lg:text-[28px] md:text-[24px] text-[22px] leading-tight">{{ nivel }}</span>
                    <span class="sr-only whitespace-nowrap">&nbsp;</span>
                    <span class="block lg:text-[32px] md:text-[28px] text-[22px] text-hgold text-left leading-tight font-serif">{{ carrera }}</span>
                    <span v-if="complemento" class="sr-only whitespace-nowrap">&nbsp;</span>
                    <span v-if="complemento" class="lg:text-[32px] md:text-[28px] text-[22px] mb-3 text-hgold text-left leading-tight font-serif">{{ complemento }}</span>
                </h2>
                <p class="mb-4">{{ intro }}</p>
                <h3 class="font-bold mb-2">Beneficios</h3>
                <p v-if="beneficios" class="mb-1">{{ beneficios }}</p>
                <p v-if="beneuno" class="mb-1 text-left">{{ beneuno }}</p>
                <p v-if="benedos" class="mb-1 text-left">{{ benedos }}</p>
                <p v-if="benetres" class="mb-3 text-left">{{ benetres }}</p>
                <h3 class=" font-bold mb-2">Perfil del estudiante</h3>
                <p class="mb-2">{{ perfil }}</p>
                <p class=""><b>Fechas:</b> {{fechas}}</p>
                <p class=""><b>Duración:</b> 2 bloques trimestrales (6 meses).</p>
            </div>
        </div>
    </section>
</template>

<style scoped>
</style>